import { Box, Flex, Icon } from '@chakra-ui/react';
import { ChevronLeft } from 'react-iconly';
import { useSteps } from 'react-step-builder';
import { useHistory } from 'react-router-dom';
import { useCloneOutreachMutation } from '@/store/query/outreaches';
import { useMixpanel } from '@/hooks/use-mixpanel';
import FlowIcon from '@/assets/icons/blueprint/Flow';
import CreateFlow from '@/assets/icons/colored/CreateFlow2';
import { OutreachForm } from './form';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { findSuggestedTimezone } from '@/lib/date';
import { selectCurrUser } from '@/store/bootstrap/selectors';
import { useSelector } from 'react-redux';
import { KText } from '@/ui-library/components/text';
import { useShowToast } from '@/hooks/useShowToast';
export const CreateFromBlueprinthWithTitle = ({
  onClose = () => {},
  blueprint = {},
  quickCreate = false,
}) => {
  const currUser = useSelector(selectCurrUser);
  const { track } = useMixpanel();
  const { jump } = useSteps();
  const [cloneOutreach, { isLoading }] = useCloneOutreachMutation();
  const toast = useShowToast();
  const history = useHistory();
  const { tFlowTimeZone } = useFlags();
  const flowDescription =
    'Engage with candidates at scale with automated emails, InMails, and LinkedIn requests, sent on behalf of anyone in the company.';

  const onClone = async (outreachFormData) => {
    try {
      // Set time_zone if not available in the Blueprint.
      const result = await cloneOutreach({
        params: {
          ...outreachFormData,
          on_step_fail: 'halt',
          on_step_fail_for_email: 'halt',
          time_zone: tFlowTimeZone
            ? blueprint?.outreach?.time_zone ||
              currUser?.time_zone ||
              findSuggestedTimezone()
            : null,
        },
        outreachId: blueprint?.outreach?.id,
      });
      if (result?.data?.id) {
        history.push(`/flows/${result?.data?.id}/steps`);
        toast({
          title: 'Flow created',
          position: 'bottom-left',
          status: 'success',
          isClosable: true,
        });
        track({
          event: 'outreach-created',
          prop: { source: 'clone' },
        });
        if (quickCreate) {
          onClose();
        }
        return result;
      }
      return result;
    } catch {
      // ignore
    }
  };

  return (
    <Flex height="inherit">
      <Flex flex="1" flexDir="column">
        <Flex height="300px" px="50px" flexDir="column" justifyContent="center">
          <Flex
            alignItems="center"
            cursor="pointer"
            _hover={{ textDecor: 'underline' }}
            fontSize="14px"
            color="secondary-700"
            onClick={() => {
              jump(1);
            }}
          >
            <Icon as={ChevronLeft} /> Back to Blueprints
          </Flex>

          <Flex
            mt="12px"
            w="48px"
            h="48px"
            border="1px solid"
            borderColor="border-color"
            borderRadius="10px"
            justifyContent="center"
            alignItems="center"
            color="secondary-700"
          >
            <Icon as={FlowIcon} />
          </Flex>
          <KText mt="12px" size="xxxl-semi-bold" color="secondary-900">
            Create a Flow
          </KText>
          <KText>{flowDescription}</KText>
        </Flex>
        <Flex flexDir="column" justifyContent="center" flex="1" px="50px">
          <OutreachForm
            blueprint={blueprint}
            onSubmit={onClone}
            onClose={onClose}
            isLoading={isLoading}
          />
        </Flex>
      </Flex>
      <Box width="500px">
        <Icon
          as={CreateFlow}
          width="500px"
          height="100%"
          bg="#4E53BC"
          borderRadius="0 15px 15px 0"
        />
      </Box>
    </Flex>
  );
};
